import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';

import Badge from '../badge';

import { ShopOfTheYearCharity } from '../../../../../../types';

import * as S from './styles';

type OwnProps = {
  mainBadgeURI: string;
  charity?: ShopOfTheYearCharity | null;
  currentYear?: number | null;
};

const SotyPageHeader = ({ mainBadgeURI, charity, currentYear }: OwnProps) => {
  const { t } = useContext(AppContext);

  return (
    <S.Header>
      <S.Logo>
        <Badge year={currentYear} src={mainBadgeURI} />
      </S.Logo>

      <S.Title>
        {t('campaigns', 'shop-of-the-year.title-with-year', {
          year: currentYear || '',
        })}
      </S.Title>

      <S.Description>
        {t('campaigns', 'shop-of-the-year.header-description', {
          year: currentYear || '',
        })}
      </S.Description>

      {charity?.logo && (
        <S.Charity>
          <span>{t('campaigns', 'shop-of-the-year.charity-in-favor')}</span>
          <S.CharityLogo src={charity.logo} alt={charity.name || ''} />
        </S.Charity>
      )}
    </S.Header>
  );
};

export default SotyPageHeader;
